module.exports = __webpack_public_path__ + "static/guide12-6390fab2646c8dcd7178d2d3431d20eb.svg";